<template>
  <!-- Home Banner -->
  <section
    class="section section-search"
    v-if="currentpath == 'index' || currentpath == 'index-page'"
  >
    <div class="container-fluid">
      <div class="banner-wrapper">
        <div class="banner-header text-center">
          <h1>Search Doctor, Make an Appointment</h1>
          <p>
            Discover the best doctors, clinic & hospital the city nearest to
            you.
          </p>
        </div>

        <!-- Search -->
        <div class="search-box">
          <form class="justify-content-center" v-show="search_by == 'location'">
            <div class="form-group search-location">
              <input
                ref="autocomplete"
                id="map"
                class="form-control"
                placeholder="Enter your address"
                type="text"
              />

              <a
                class="form-text d-inline"
                href="#"
                @click="set_search_by('state_city')"
                >or Search by your State and Ciy</a
              >
            </div>
          </form>
          <div class="container" v-show="search_by == 'state_city'">
            <div class="row search-state-city">
              <div class="col pr-0">
                <v-select
                  class="mr-2"
                  name="state"
                  required=""
                  label="state"
                  placeholder="select state"
                  v-model="selected_state"
                  :reduce="(option) => option.state"
                  @input="get_cities()"
                  :options="states"
                >
                </v-select>
              </div>
              <div class="col">
                <v-select
                  class="mr-2"
                  name="city"
                  required=""
                  label="city"
                  placeholder="select city"
                  v-model="selected_city"
                  :reduce="(option) => option.city"
                  :options="cities"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <a
                  class="form-text d-inline"
                  href="#"
                  @click="set_search_by('location')"
                  >or Search by your Location</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /Search -->
      </div>
    </div>
  </section>
  <!-- /Home Banner -->

  <section
    class="section section-search-2"
    v-else-if="currentpath == 'index-2'"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img
            src="@/assets/img/logo/Knee_Xpert_Logo_Reverse.svg"
            class="img-fluid search-img"
            alt=""
          />
        </div>
        <div class="col-md-6 search-doctor">
          <div class="search-area bg-white">
            <h2 class="text-center">Search Doctor, Make an Appointment</h2>
            <form class="search-input">
              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Location</label>
                    <input type="text" class="form-control" value="" />
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Gender</label>
                    <select class="form-control">
                      <option>Male</option>
                      <option>Fe Male</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Department</label>
                    <select class="form-control">
                      <option>Surgen</option>
                      <option>Cardiologist</option>
                      <option>Gynacologist</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button
                  type="submit"
                  class="btn btn-primary search-btn submit-btn"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="home" class="divider" v-else-if="currentpath == 'index-3'">
    <div class="container-fluid p-0">
      <!--- slider ---->
      <div
        id="carouselExampleIndicators"
        class="carousel slide carousel-fade"
        data-ride="carousel"
        data-interval="2500"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              class="d-block w-100"
              src="@/assets/img/slider/slider-1.jpg"
              alt="First slide"
            />
            <div class="carousel-caption d-none d-md-block">
              <span>We Provide Solution</span>
              <h2>To stressless Life</h2>
              <p>
                People who are more perfectionist are most likely to be
                depressed,<br />Because they stress themselves out so much.
              </p>
            </div>
          </div>
          <div class="carousel-item">
            <img
              class="d-block w-100"
              src="@/assets/img/slider/slider-2.jpg"
              alt="Second slide"
            />
            <div class="carousel-caption d-none d-md-block">
              <span>We Provide Solution</span>
              <h2>Health Care Solution</h2>
              <p>
                Every day we bring hope to millions of children in the
                world's<br />
                hardest places as a sign of God's unconditional love.
              </p>
            </div>
          </div>
          <div class="carousel-item">
            <img
              class="d-block w-100"
              src="@/assets/img/slider/slider-3.jpg"
              alt="Third slide"
            />
            <div class="carousel-caption d-none d-md-block">
              <span>We Provide total</span>
              <h2>Personalised care</h2>
              <p>
                People who are more perfectionist are most likely to be
                depressed,<br />Because they stress themselves out so much.
              </p>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <!--- /slider ---->
      <!-- Search -->
      <div class="banner-wrapper">
        <div class="search-box search-box-3">
          <form>
            <div class="form-group search-location">
              <input
                type="text"
                class="form-control"
                placeholder="Search Location"
              />
            </div>
            <div class="form-group search-info">
              <input
                type="text"
                class="form-control"
                placeholder="Search Doctors, Clinics, Hospitals, Diseases Etc"
              />
            </div>
            <button
              @click="searchPath"
              class="btn btn-primary search-btn btn-search mt-0"
            >
              <i class="fas fa-search"></i> <span>Search</span>
            </button>
          </form>
        </div>
      </div>
      <!-- /Search -->
    </div>
  </section>
  <section id="home" class="divider" v-else-if="currentpath == 'index-5'">
    <div class="pharmacy-home-slider slider">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/img/slide1.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/slide2.jpg" alt="" />
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div class="banner-wrapper">
          <div class="banner-header text-center">
            <h1>Search Doctor, Make an Appointment</h1>
            <p>
              Discover the best doctors, clinic & hospital the city nearest to
              you.
            </p>
          </div>
          <!-- Search -->
          <div class="search-box">
            <form action="/search">
              <div class="form-group search-location">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Location"
                />
                <span class="form-text">Based on your Location</span>
              </div>
              <div class="form-group search-info">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Doctors, Clinics, Hospitals, Diseases Etc"
                />
                <span class="form-text">Ex : Dental or Sugar Check up etc</span>
              </div>
              <button type="submit" class="btn btn-primary search-btn mt-0">
                <i class="fas fa-search"></i> <span>Search</span>
              </button>
            </form>
          </div>
          <!-- /Search -->
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </section>
  <section
    class="section-search-pharmacy"
    v-else-if="currentpath == 'pharmacy'"
  >
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="banner-wrapper2">
            <div class="search-box1">
              <form>
                <p class="mb-0 mr-3">Find a Pharmacy</p>
                <div class="form-group search-location1 postion-relative">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter your location / Pincode"
                    style="padding-left: 15px"
                  />
                  <span class="search-detect">Detect</span>
                </div>

                <button @click="searchPath" class="btn btn-primary search-btn">
                  <i class="fas fa-search"></i> <span>Search</span>
                </button>
              </form>
            </div>
            <!-- /Search -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Home Banner -->
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CommonApi from "../../services/CommonApi";

export default {
  data() {
    return {
      lattitude: "",
      longitude: "",
      search_by: "location",
      states: [],
      selected_state: "",
      cities: [],
      selected_city: "",
    };
  },
  components: {
    VueGoogleAutocomplete,
  },
  watch: {
    selected_state: function(val) {
      this.$emit("update-state", val);
    },
    selected_city: function(val) {
      this.$emit("update-city", val);
    },
    lattitude: function(val) {
      this.$emit("update-lattitude", val);
    },
    longitude: function(val) {
      this.$emit("update-longitude", val);
    },
  },
  mounted() {
    this.get_states();
    this.getCurrentLocation();
    const autocomplete = new google.maps.places.Autocomplete(
      this.$refs["autocomplete"]
    );
    autocomplete.addListener("place_changed", function() {
      var place = autocomplete.getPlace();
      var latitude = place.geometry.location.lat();
      var longitude = place.geometry.location.lng();
    });
    if ($(".pharmacy-home-slider .swiper-container").length > 0) {
      var swiper = new Swiper(".pharmacy-home-slider .swiper-container", {
        loop: true,
        speed: 1000,
        pagination: {
          el: ".pharmacy-home-slider .swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: ".pharmacy-home-slider .swiper-button-next",
          prevEl: ".pharmacy-home-slider .swiper-button-prev",
        },
      });
    }
  },
  computed: {
    currentpath() {
      return this.$route.name;
    },
  },
  methods: {
    async get_states() {
      await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
        this.states = res.message;
      });
    },
    async get_cities() {
      this.selected_city = "";
      const params = new URLSearchParams();
      params.append("state", this.selected_state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },
    set_search_by(search) {
      this.search_by = search;
    },
    searchPath() {
      this.$router.push("/doctor/search");
    },
    getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(p) {
          var LatLng = new google.maps.LatLng(
            p.coords.latitude,
            p.coords.longitude
          );
          var geocoder = (geocoder = new google.maps.Geocoder());

          geocoder.geocode({ latLng: LatLng }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (results[1]) {
                document.getElementById("map").value =
                  results[1].formatted_address;
              }
            }
          });
        });
      } else {
        alert("Geo Location feature is not supported in this browser.");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/HomeBanner.vue